<div
    class="row-container"
    [ngbPopover]="tooltipTemplate"
    [openDelay]="300"
    [closeDelay]="300"
    triggers="mouseenter:mouseleave"
    container="body"
    popoverClass="rask-icon-popover"
>
    <i class="fal fa-sm fa-tree icon" aria-hidden="true"></i>
    <span class="w-100 plFixProdukt">{{input.naturalKey}} - {{input.title}}</span>
    <br />
    <span class="w-100 text-end float-end">{{input.metadata["produktgrupp"]}}</span>
</div>
